import { render, staticRenderFns } from "./ActivityTabCalls.vue?vue&type=template&id=3acb0fc3&"
import script from "./ActivityTabCalls.vue?vue&type=script&lang=js&"
export * from "./ActivityTabCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports